import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GeoSearchInput from '../../components/geo-search-input';
import SearchMap from '../../components/search-map';
import * as selectors from '../../reducers';
import styles from './search-page.module.scss';
import { setActiveRegion, setActiveDam, setActivePage } from '../../actions/ui';
import DroughtVis from '../../components/dams-vis';
import Select from 'react-select';

class SearchPage extends Component {
  constructor() {
    super();
    this.selectCouncil = this.selectCouncil.bind(this);
    this.handleListClick = this.handleListClick.bind(this);
  }
  selectCouncil(councilId) {
    const { setActiveRegion, setActivePage } = this.props;
    setActiveRegion(councilId);
    setActivePage('region');
  }

  handleListClick(council) {
    return (e) => {
      window.scrollTo(0, 0);
      this.selectCouncil(council.id);
    };
  }

  renderCouncils() {
    const { regions } = this.props;
    return (
      <ul className={styles.councilList}>
        {regions
          .filter((c) => {
            // Don't make a page for the "Other - inside or outside QLD" category
            return !c.name.includes('Other');
          })
          .map((council, i) => (
            <li key={i} className={styles.councilListElement}>
              <button
                type="button"
                className={styles.councilListElementButton}
                onClick={this.handleListClick(council)}
              >
                {council.lgaName}
              </button>
            </li>
          ))}
      </ul>
    );
  }
  render() {
    const { dams, activeDam } = this.props;

    return (
      <div>
        <div className={styles.searchPageHeader}>
          <div className={styles.mainHeading}>Understanding your dams</div>
          <hr className={styles.mainHeadingLine} />
          <div className={styles.subHeading}>
            <p>
              This Queensland Audit Office interactive map allows you to explore
              information on the dams regulated by the Department of Regional
              Development, Manufacturing and Water. You can see information on
              dam ownership, location, planned upgrades and other information on
              the structure, capacity, and age of dams. You can also find links
              to the Emergency Action Plans for dams in your local area. If you
              have any concerns over the safety of a water dam, contact the
              owner or email{' '}
              <a href="mailto:damsafety@rdmw@qld.gov.au" target="_blank">
                damsafety@rdmw@qld.gov.au
              </a>
              . In the event of an emergency call emergency services on 000; you
              can get more information from{' '}
              <a
                href="https://www.business.qld.gov.au/industries/mining-energy-water/water/industry-infrastructure/dams/queensland"
                title="Dams in Queensland"
                target="_blank"
              >
                Business Queensland
              </a>
              .
            </p>
            <p>
              This data was collected in November 2021 and does not contain live
              updates.
            </p>
          </div>
        </div>
        <div className={styles.section}>
          <h3 className={styles.sectionHeading}>Search the map</h3>
          <div className={styles.searchWrapper}>
            <GeoSearchInput onCouncilSelect={this.selectCouncil} />
          </div>
          <div className={styles.mapRow}>
            <div className={styles.mapWrapper}>
              <SearchMap onCouncilSelect={this.selectCouncil} />
            </div>
            <div className={styles.entityListWrapper}>
              <h4>Entities</h4>
              <ul>
                <li>
                  <p className={styles.subHeading}>Bulk water suppliers</p>
                </li>
                <li className={styles.li}>Sunwater</li>
                <li className={styles.li}>Seqwater</li>
              </ul>
              <p
                className={styles.subHeading}
                style={{ paddingTop: 10, paddingBottom: 5 }}
              >
                Dam information (November 2021)
              </p>
              <DroughtVis />
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <h3 className={styles.sectionHeading}>Select a dam</h3>
          <Select
            name="damDropdown"
            value={
              activeDam
                ? { value: activeDam.dam, label: activeDam.dam }
                : undefined
            }
            onChange={(x) => {
              this.props.setActiveDam(x.value);
              const dam = dams.find((d) => d.dam === x.value);
              this.selectCouncil(dam.region);
              window.scrollTo(0, 0);
            }}
            options={dams.map((x) => ({
              value: x.dam,
              label: x.dam,
            }))}
            clearable={false}
          />
        </div>
        <div className={styles.section}>
          <h3 className={styles.sectionHeading}>
            Select local government area from list
          </h3>
          <div className={styles.listWrapper}>{this.renderCouncils()}</div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  setActiveRegion,
  setActiveDam,
  setActivePage,
};

const mapStateToProps = (state) => ({
  regions: selectors.getRegions(state),
  dams: selectors.getDams(state),
  activeDam: selectors.getActiveDam(state),
});

SearchPage.propTypes = {
  regions: PropTypes.arrayOf(PropTypes.object),
  dams: PropTypes.arrayOf(PropTypes.object),
  activeDam: PropTypes.object,
  setActiveRegion: PropTypes.func,
  setActiveDam: PropTypes.func,
  setActivePage: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);



// WEBPACK FOOTER //
// ./src/pages/search-page/search-page.js